import { ChakraProvider } from "@chakra-ui/react";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import LoadingIndicator from "./src/components/LoadingIndicator";
import { IncidentLogPdfContextProvider } from "./src/containers/IncidentLogPdf/IncidentLogPdfContext";
import { AppContextProvider } from "./src/contexts/AppContext";
import { EntryContextProvider } from "./src/contexts/EntryContext";
import { IncidentLogContextProvider } from "./src/contexts/IncidentLogContext";
import { MainSidebarContextProvider } from "./src/contexts/MainSidebarContext";
import { OrfContextProvider } from "./src/contexts/OrfContext";
import { SidebarContextProvider } from "./src/contexts/SidebarContext";
import theme from "./src/styles/theme";

/**
 * WithOriginalContext provides the original contexts that the React frontend requires.
 * It is intended to make further refactoring easier.
 */
export function WithOriginalContext(props: { children: JSX.Element[] }) {
  // TODO: get rid of this, it's only used in the login page and we can do better.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  });

  return (
    // TODO: strip out Chakra to favor UnoCSS/Headless
    // TODO: collapse the contexts into global state and get rid of this
    <AppContextProvider>
      <QueryClientProvider client={queryClient}>
        <SidebarContextProvider>
          <MainSidebarContextProvider>
            <ChakraProvider theme={theme}>
              <Suspense fallback={<LoadingIndicator />}>
                <IncidentLogContextProvider>
                  <OrfContextProvider>
                    <IncidentLogPdfContextProvider>
                      <EntryContextProvider>
                        {props.children}
                      </EntryContextProvider>
                    </IncidentLogPdfContextProvider>
                  </OrfContextProvider>
                </IncidentLogContextProvider>
              </Suspense>
            </ChakraProvider>
          </MainSidebarContextProvider>
        </SidebarContextProvider>
      </QueryClientProvider>
    </AppContextProvider>
  );
}
